import React from 'react';
import {Link} from 'react-router-dom';
import ContentWrapper from '../Layout/ContentWrapper';
import {Button} from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2'
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'moment-timezone';

moment.tz.setDefault("America/Halifax");

class TripsList extends React.Component {
    constructor(props) {
        super(props);

        this.updateDates = this.updateDates.bind(this);
        this.goToTrip = this.goToTrip.bind(this);

        this.state = {
            loading: true,
            trips: [],
            trips_sort: [],
            startDate: (localStorage.getItem('trip_startDate') != null ? moment(localStorage.getItem('trip_startDate')) : moment().endOf('day')),
            endDate: (localStorage.getItem('trip_endDate') != null ? moment(localStorage.getItem('trip_endDate')) : moment().add(6, 'days')),
            ranges: {
                'Today': [moment(), moment()],
                'Next 7 Days': [moment().add(6, 'days'), moment().endOf('day')],
                'Next 30 Days': [moment().add(30, 'days'), moment().endOf('day')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment().endOf('day')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'All Time': [moment("01 Jan 2023"), moment("31 Dec 2024")]
            },
            sort: (localStorage.getItem('trip_sort') != null ? localStorage.getItem('trip_sort') : "trip_date"),
            sort_order: (localStorage.getItem('trip_sort_order') != null ? localStorage.getItem('trip_sort_order') * 1 : -1),
        };
    }

    componentDidMount() {
        document.title = "Trip Sheets | Greenhaven Transportation";
        this.updateTrips();
    }

    updateTrips() {
        var self = this;
        const params = {
            startDate: self.state.startDate.format('YYYY-MM-DD'),
            endDate: self.state.endDate.format('YYYY-MM-DD')
        };
        axios.get('/api/tripsheets', {params})
            .then(function (response) {
                const trips = response.data && Array.isArray(response.data.trips) ? response.data.trips : [];
                self.setState({
                    trips: trips,
                    loading: false
                });
                self.onSort(null, self.state.sort)
            })
            .catch(function (error) {
                if (error && error.response && error.response.status === 401) {
                    if (self.props.userHasAuthenticated) {
                        self.props.userHasAuthenticated(false);
                    }
                    if (self.props.history) {
                        self.props.history.push('/login');
                        return;
                    }
                }
                Swal("Error", (error.response && error.response.data && (error.response.data.message || error.response.data.Message)) || 'Failed to load trips', "error");
            });
    }

    // on date range change
    updateDates(event, picker) {
        if (event.type == "apply") {
            localStorage.setItem('trip_startDate', picker.startDate);
            localStorage.setItem('trip_endDate', picker.endDate);
            this.setState({
                startDate: picker.startDate,
                endDate: picker.endDate
            }, function () {
                this.updateTrips()
            });
        }
    }

    goToTrip = (trip_id) => {
        this.props.history.push("/trips/create?trip_id=" + trip_id);
    };

    onSort(event, sortKey) {
        localStorage.setItem('trip_sort', sortKey);
        localStorage.setItem('trip_sort_order', this.state.sort_order);
        var sort_order = this.state.sort_order * -1;
        if (sortKey != this.state.sort) {
            sort_order = 1;
        }

        function format_search_val(val) {
            if (typeof val == "undefined") {
                return 1;
            } else if (isNaN(val)) {
                return val.toLowerCase();
            } else {
                return parseFloat(val);
            }
        }

        const trips = this.state.trips.slice();
        const sorted = trips.sort((a, b) => {
            if (typeof format_search_val(a[sortKey]) == "string" && typeof format_search_val(b[sortKey]) != "string") {
                return (sort_order == -1 ? -1 : 1);
            } else {
                if (format_search_val(a[sortKey]) > format_search_val(b[sortKey])) {
                    return (sort_order == -1 ? -1 : 1);
                }
                if (format_search_val(a[sortKey]) < format_search_val(b[sortKey])) {
                    return (sort_order == -1 ? 1 : -1);
                }
            }
            return 0;
        });
        this.setState({
            sort: sortKey,
            sort_order: sort_order,
            trips_sort: sorted
        });
    }

    render() {
        // date range selector variables
        let start = this.state.startDate.format('MMM. D/YY');
        let end = this.state.endDate.format('MMM. D/YY');
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }
        let totalHours = 0;
        let totalKm = 0;

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>Completed Trip Sheets</div>
                    <div className="ml-auto">
                        <Link to="trips/create" className="btn btn-primary"><i className="fas fa-plus"></i> New Trip Sheet</Link>
                    </div>
                </div>
                <div className="mb-3 form-inline" style={{zIndex: 1000}}>
                    <DateRangePicker
                        onEvent={this.updateDates}
                        autoUpdateInput={true}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        ranges={this.state.ranges}
                    >
                        <button type="button" className="btn btn-primary selected-date-range-btn mr-1">
                            Summary Period: <b>{label}</b> <span className="fas fa-caret-down fa-sm"></span>
                        </button>
                    </DateRangePicker>
                </div>
                <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                    <div>
                        <div className="card-header">
                            <div className="card-title">{this.state.trips_sort.length} Trip Sheets</div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={(this.state.trips_sort.length > 0 ? "table table-hover table-pointer text-right" : "d-none")}>
                                    <thead>
                                    <tr>
                                        <th className="text-left" onClick={e => this.onSort(e, 'trip_id')}><i className="fas fa-sort"></i> Trip #</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'trip_date')}><i className="fas fa-sort"></i> Date</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'vehicle_name')}><i className="fas fa-sort"></i> Vehicle</th>
                                        <th className="text-right" onClick={e => this.onSort(e, 'total_hours')}><i className="fas fa-sort"></i> Hours</th>
                                        <th className="text-right" onClick={e => this.onSort(e, 'total_distance_km')}><i className="fas fa-sort"></i> KMs</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.trips_sort.map((trip) => {
                                        const hours = trip.total_hours || 0;
                                        const kms = trip.total_distance_km || 0;
                                        totalHours += (typeof hours === 'number' ? hours : parseFloat(hours) || 0);
                                        totalKm += (typeof kms === 'number' ? kms : parseFloat(kms) || 0);
                                        return (
                                            <tr key={trip.trip_id} onClick={this.goToTrip.bind(this, trip.trip_id)}>
                                                <td className="text-left">{trip.trip_id}</td>
                                                <td className="text-left">{trip.trip_date ? moment(trip.trip_date).format('MMM. D/YY') : '--'}</td>
                                                <td className="text-left">{trip.vehicle_name || ''}</td>
                                                <td className="text-right">{trip.total_hours != null ? trip.total_hours : ''}</td>
                                                <td className="text-right">{trip.total_distance_km != null ? trip.total_distance_km : ''}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <th className="text-right" colSpan="3">Total:</th>
                                        <th className="text-right">{totalHours}</th>
                                        <th className="text-right">{totalKm}</th>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

export default (TripsList);